import p, { stdSerializers as a } from "pino";
import { z as g } from "zod";
const v = ["debug", "info", "warn", "error", "fatal", "audit"], E = g.enum(v), u = !process.env.NODE_ENV || process.env.NODE_ENV === "production", f = process.env.NEXT_PHASE === "phase-production-build", s = () => {
  let e = "info";
  u && (e = "warn"), f && (e = "error");
  const o = process.env.LOG_LEVEL, t = E.safeParse(o);
  return t.success && (e = t.data), e;
}, m = {
  level: s(),
  serializers: {
    err: a.err,
    req: a.req,
    res: a.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  name: "formbricks"
}, L = () => {
  const e = process.env.NEXT_RUNTIME === "nodejs" && !!process.env.OTEL_EXPORTER_OTLP_ENDPOINT, o = process.env.OTEL_SERVICE_NAME ?? "formbricks", t = process.env.npm_package_version ?? "0.0.0", d = {
    target: "pino-opentelemetry-transport",
    options: {
      resourceAttributes: {
        "service.name": o,
        "service.version": t,
        "deployment.environment": process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development"
      }
    },
    level: s()
  }, i = {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,warn:40,error:50,fatal:60,audit:90",
      useOnlyCustomProps: !0
    },
    level: s()
  };
  if (!u)
    return e ? { targets: [i, d] } : { target: i.target, options: i.options };
  if (e)
    return { targets: [{
      target: "pino/file",
      options: { destination: 1 },
      // stdout
      level: s()
    }, d] };
}, c = L(), T = c !== void 0 && "targets" in c, N = {
  ...m,
  transport: c,
  ...!T && {
    formatters: {
      level: (e) => ({ level: e })
    }
  }
}, r = p(N), h = {
  debug: r.debug.bind(r),
  info: r.info.bind(r),
  audit: r.audit.bind(r),
  warn: r.warn.bind(r),
  error: r.error.bind(r),
  fatal: r.fatal.bind(r)
}, b = {
  ...h,
  withContext: (e) => r.child(e),
  request: (e) => r.child({
    method: e.method,
    url: e.url
  })
}, l = b, n = (e, o) => {
  o && l.error(o, `Error during shutdown (${e})`), l.info({ event: e }, "Process is exiting"), r.flush();
}, _ = () => {
  process.env.NEXT_RUNTIME === "nodejs" && (process.on("uncaughtException", (e) => {
    n("uncaughtException", e);
  }), process.on("unhandledRejection", (e) => {
    n("unhandledRejection", e);
  }), process.on("SIGTERM", () => {
    n("SIGTERM");
  }), process.on("SIGINT", () => {
    n("SIGINT");
  }));
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    _();
  } catch (e) {
    l.error(e, "Error attaching process event handlers");
  }
export {
  l as logger
};
